import React from 'react';
import type { PlacedHardware } from '../../hardware/placeHardware';

/**
 * Reusable hardware artwork, placed in authored slab space.
 * Size comes from the catalogue `renderSize`. The authored product anchor is
 * aligned to the slab `#hardware-guides` anchor; the SVG viewBox is only the
 * artwork's internal coordinate system.
 */
export const PlacedHardwareArtwork: React.FC<{
  placement: PlacedHardware;
}> = ({ placement }) => (
  <image
    data-part="door-hardware"
    data-hardware-product={placement.productId}
    data-hardware-placement={placement.placementId}
    href={placement.publicPath}
    x={placement.x}
    y={placement.y}
    width={placement.width}
    height={placement.height}
    preserveAspectRatio="none"
  />
);
